import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { setError } from "../appSlice";

export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await get("company/list", "", {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const getCompany = createAsyncThunk(
  "get/Company",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await get("company/get", `id=${id}`);
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveCompany = createAsyncThunk(
  "companies/saveCompany",
  async (company, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await post("company/save", company, {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      if (response.data) {
        dispatch(addCompany(response.data));
      }
      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Update an existing company
export const updateCompany = createAsyncThunk(
  "companies/updateCompany",
  async (company, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await post("company/save", company, {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      dispatch(editCompany(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Action creators for adding and editing companies
export const addCompany = (company) => ({
  type: "companies/addCompany",
  payload: company,
});

export const editCompany = (updatedCompany) => ({
  type: "companies/editCompany",
  payload: updatedCompany,
});

// Slice definition
const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    companies: [],
    loading: false,
    error: null,
  },
  reducers: {
    addCompany: (state, action) => {
      if (action.payload) {
        state.companies.push(action.payload);
      }
    },
    editCompany: (state, action) => {
      const index = state.companies.findIndex(
        (company) => company.id === action.payload.id
      );
      if (index !== -1) {
        state.companies[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default companiesSlice.reducer;
